import React from 'react';
import PropTypes from 'prop-types';
import { ACCEPT_PRIVACY_POLICY, EMAIL, FIRST_NAME, FORM_PROTECTION, LAST_NAME, OWNER_SIGNUP, SIGN_UP } from "../../../utils/default-strings";
import { Form } from "../../collections/Form";
import { TextInput } from "../../inputs/TextInput";
import { Checkbox } from "../../inputs/Checkbox";
import { getPrivacyConsentLabel } from "../../../utils/get-privacy-consent-label";
import { EMAIL_MAX_CHARACTERS, FIRST_NAME_MAX_CHARACTERS, LAST_NAME_MAX_CHARACTERS } from "./constants";
export var Component = function Component(_ref) {
  var botProtectionMessage = _ref.botProtectionMessage,
      emailInputLabel = _ref.emailInputLabel,
      errorMessage = _ref.errorMessage,
      firstNameInputLabel = _ref.firstNameInputLabel,
      headingText = _ref.headingText,
      isBotProtected = _ref.isBotProtected,
      isPrivacyConsentRequired = _ref.isPrivacyConsentRequired,
      lastNameInputLabel = _ref.lastNameInputLabel,
      onSubmit = _ref.onSubmit,
      privacyConsentLabelText = _ref.privacyConsentLabelText,
      privacyConsentLabelLinkText = _ref.privacyConsentLabelLinkText,
      privacyConsentLabelLinkUrl = _ref.privacyConsentLabelLinkUrl,
      submitButtonText = _ref.submitButtonText,
      successMessage = _ref.successMessage,
      validation = _ref.validation;
  return React.createElement(Form, {
    errorMessage: errorMessage,
    headingText: headingText,
    onSubmit: onSubmit,
    submitButtonText: submitButtonText,
    successMessage: successMessage,
    validation: validation
  }, React.createElement(TextInput, {
    autoComplete: "given-name",
    label: firstNameInputLabel,
    maxCharacters: EMAIL_MAX_CHARACTERS,
    name: "firstName"
  }), React.createElement(TextInput, {
    autoComplete: "family-name",
    label: lastNameInputLabel,
    maxCharacters: LAST_NAME_MAX_CHARACTERS,
    name: "lastName"
  }), React.createElement(TextInput, {
    autoComplete: "email",
    label: emailInputLabel,
    maxCharacters: FIRST_NAME_MAX_CHARACTERS,
    name: "email"
  }), isBotProtected && botProtectionMessage, isPrivacyConsentRequired && React.createElement(Checkbox, {
    label: getPrivacyConsentLabel(privacyConsentLabelText, privacyConsentLabelLinkUrl, privacyConsentLabelLinkText),
    name: "privacyConsent"
  }));
};
Component.displayName = 'OwnerSignUp';
Component.defaultProps = {
  botProtectionMessage: FORM_PROTECTION,
  emailInputLabel: EMAIL,
  errorMessage: '',
  firstNameInputLabel: FIRST_NAME,
  headingText: OWNER_SIGNUP,
  isBotProtected: false,
  isPrivacyConsentRequired: false,
  lastNameInputLabel: LAST_NAME,
  onSubmit: Function.prototype,
  privacyConsentLabelLinkText: undefined,
  privacyConsentLabelLinkUrl: undefined,
  privacyConsentLabelText: ACCEPT_PRIVACY_POLICY,
  submitButtonText: SIGN_UP,
  successMessage: '',
  validation: {}
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  botProtectionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  emailInputLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  firstNameInputLabel: PropTypes.string,
  headingText: PropTypes.string,
  isBotProtected: PropTypes.bool,
  isPrivacyConsentRequired: PropTypes.bool,
  lastNameInputLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  privacyConsentLabelLinkText: PropTypes.string,
  privacyConsentLabelLinkUrl: PropTypes.string,
  privacyConsentLabelText: PropTypes.node,
  submitButtonText: PropTypes.string,
  successMessage: PropTypes.string,
  validation: PropTypes.shape({
    email: PropTypes.object,
    firstName: PropTypes.object,
    lastName: PropTypes.object,
    privacyConsent: PropTypes.object
  })
} : {};